import React from 'react';
import { ChatManager } from '@rebelnerds/chat-saas-client';
import { isMobile } from 'react-device-detect';
import { Message } from '@material-ui/icons';
import classnames from 'classnames';
import { observer } from 'mobx-react';

import LiveBroadcastStore from '../../store/LiveBroadcastStore';
import GroupShowStore from '../../store/GroupShowStore';
import { isSubscribedToGroupShowAnchor, isSubscribedToGroupShowAnchorByUsername } from '../../utils/helpers';
import callApi from '../../utils/callApi';

import BroadcastChatMessage from './BroadcastChatMessage/BroadcastChatMessage';
import BroadcastChatHeader from './BroadcastChatHeader/BroadcastChatHeader';
import BroadcastChatInput from './BroadcastChatInput/BroadcastChatInput';
import SpotlightChatNotificationLabel from './SpotlightChatNotificationLabel';


import './css/BroadcastChat.css';
import './css/BroadcastChat.mobile.css';
import { TEMPTED_WEB_CHAT_ACCESS } from '../../constants/apiUrls/apiUrls';
import AnchorStore from '../../store/AnchorStore';
import { RootStoreContext } from '../../context';
import AnchorDashboardStore from '../../store/fragments/AnchorDashboardStore';


const GROUP_SHOW_PARTICIPANT_STOPPED = 'GROUP_SHOW_PARTICIPANT_STOPPED';
const GROUP_SHOW_PARTICIPANT_JOINED = 'GROUP_SHOW_PARTICIPANT_JOINED';
const CHAT_SCROLL_TIMEOUT = 500;
const MAX_MESSAGE_LENGTH_IN_CHARS = 80;

@observer
class BroadcastChat extends React.PureComponent {
  static contextType = RootStoreContext;
  username = null;
  anchorUsername = null;
  activeChatSession = null;

  chatConversationWrapperRef = React.createRef();

  state = {
    inputMessage: '',
    messageMetadata: null,
    roomState: {},
    roomMessages: [],
    subscribed: false,
    landscapeChatVisibility: true,
    isSpotlight: false,
    spotlightedByAnchorNickname: null,
    spotlightedByAnchorUsername: null,
    chatScrollTimeout: null,
  };

  componentWillUnmount() {
    const { chatScrollTimeout } = this.state;
    document.removeEventListener('myCustomEvent', this.handleEv);
    if (chatScrollTimeout) {
      clearTimeout(chatScrollTimeout);
    }
  }

  handleEv = (e) => {
    const { changeNsfwFlag } = this.props;
    changeNsfwFlag(e.detail.nsfw);
  };

  componentDidMount() {

    document.addEventListener('myCustomEvent', this.handleEv, false);

    const { user, isBroadcaster, anchor, broadcasting, guestUser, isSpotlighing } = this.props;
    this.username = user.user ? user.user.username.toLowerCase() : guestUser;
    const anchorUser = user?.user?.account?.anchor;
    if (anchorUser) {
      AnchorDashboardStore.setFanAliases(anchorUser, anchorUser?.id);
    }
    this.anchorUsername = isBroadcaster ? this.username : anchor.username;
    if (broadcasting || isSpotlighing) {
      if (this.props.isTulumRealityShow) {
        this.startTulumChat();
      } else {
        this.startChat(this.props.streamingSourceType);
      }
    }

  }

  componentWillReceiveProps(newProps) {
    const { user } = this.props;
    if (this.props.broadcasting !== newProps.broadcasting) {
      if (newProps.broadcasting === true) {
        if (newProps.streamingSourceType !== this.props.streamingSourceType) {
          this.startChat(newProps.streamingSourceType);
        } else {
          this.startChat(this.props.streamingSourceType);
        }

      } else {
        this.stopChat();
      }
    }
    if (this.props.nsfw !== newProps.nsfw && user?.user?.account?.anchor) {
      this.activeChatSession && this.activeChatSession.updateRoom(false, { nsfw: newProps.nsfw });
    }

    if (this.props.chatService?.chatServiceUrl !== newProps.chatService?.chatServiceUrl && this.props.isTulumRealityShow) {
      this.startTulumChat(newProps.chatService);
    }
  }

  startTulumChat = (chatDetails = null) => {
    const { chatService } = this.props;
    if (chatService) {
      ChatManager.init(chatService.chatServiceUrl, 'tempted');
      ChatManager.createSession(chatService.username, chatService.roomName, chatService.token, this.chatSessionHandler);
    }

    if (chatDetails) {
      ChatManager.init(chatDetails.chatServiceUrl, 'tempted');
      ChatManager.createSession(chatDetails.username, chatDetails.roomName, chatDetails.token, this.chatSessionHandler);
    }
  };

  startChat = (streamingSourceType) => {
    const { chatService, chatServiceTempted, guestUser, isSpotlighing, spotlighedAnchorUsername } = this.props;
    const anchorUsername = isSpotlighing ? spotlighedAnchorUsername : this.anchorUsername;
    if (streamingSourceType === 'TEMPTED') {
      if (chatServiceTempted) {
        if (chatServiceTempted[0] && chatServiceTempted[0].custom && chatServiceTempted[0].custom.roomName) {
          // a group show has a custom room name
          ChatManager.createSession(guestUser, chatServiceTempted[0].custom.roomName, chatServiceTempted[0].token, this.chatSessionHandler);
        } else {
          ChatManager.init(chatServiceTempted.url, 'tempted');
          ChatManager.createSession(guestUser, anchorUsername, chatServiceTempted.token, this.chatSessionHandler);
        }
      } else {
        ChatManager.init(chatService.url, 'nakednews');
        ChatManager.createSession(guestUser, anchorUsername, this.props.chatService.token, this.chatSessionHandler);
      }
    } else {
      ChatManager.init(chatService.url, 'nakednews');
      ChatManager.createSession(guestUser, this.anchorUsername, this.props.chatService.token, this.chatSessionHandler);
    }
  };

  stopChat = () => {
    if (this.activeChatSession) {
      this.activeChatSession.closeRoom();
    }
  };

  chatSessionHandler = (chatSession, error) => {
    const { isBroadcaster } = this.props;
    if (error) {
      console.error(error);
    } else {
      this.activeChatSession = chatSession;
      if (isBroadcaster) {
        this.activeChatSession.createAndJoinRoom('custom status', {}, this.joinRoomHandler);
      } else {
        this.activeChatSession.joinRoom(this.joinRoomHandler);
      }
    }
  };

  joinRoomHandler = (error) => {
    if (error) {
      console.error(error);
    } else {
      this.activeChatSession.setRoomStateListener(this.roomStateListener);
      this.activeChatSession.setRoomMessagesListener(this.roomMessagesListener);
      this.activeChatSession.setRoomUsersCountListener(this.props.roomUsersCountListener);
      // TODO
      // this.activeChatSession.setRoomRosterListener(roomRosterListener);
    }
  };

  roomStateListener = (roomStateEvent) => {
    const {
      changeNsfwFlag,
      guestUser,
      user,
      anchorId,
      isSpotlighing,
    } = this.props;
    const { isInGroupShow } = GroupShowStore;
    let chatOnline = (roomStateEvent.type === 'ROOM_STATE_UPDATE');
    const customEvent = roomStateEvent.data ? roomStateEvent.data.custom : null;
    const isSpotlight = customEvent?.isSpotlight;
    const spotlightedByAnchorNickname = customEvent?.isSpotlightByTemptationNickname;
    const isSpotlightByTemptationUsername = customEvent?.isSpotlightByTemptationUsername;
    const broadcastingTemptationUsername = customEvent?.broadcastingTemptationUsername;
    const broadcastingTemptationId = customEvent?.broadcastingTemptationId;
    const broadcastingTemptationNickname = customEvent?.broadcastingTemptationNickname;
    const spotlights = customEvent?.spotlights || [];

    LiveBroadcastStore.setBroadcastingTemptation({
      id: broadcastingTemptationId,
      nickname: broadcastingTemptationNickname,
      username: broadcastingTemptationUsername
    })
    LiveBroadcastStore.setIsSpotlight(isSpotlight);
    LiveBroadcastStore.setSpotlightedByAnchorNickname(spotlightedByAnchorNickname);
    LiveBroadcastStore.setSpotlights(spotlights);
    if (roomStateEvent.type === 'ROOM_CLOSED') {
      this.props.onBroadcasterClosedSession && this.props.onBroadcasterClosedSession();
      this.activeChatSession.leaveRoom();
      if (isInGroupShow) {
        GroupShowStore.resetRemainingGroupShowData();
      }
    }

    if (isSpotlighing && customEvent?.isSpotlight === false) {
      this.props.onSpotlighterClosedSession && this.props.onSpotlighterClosedSession();
      chatOnline = false;
      this.activeChatSession.leaveRoom();
    }

    if (isInGroupShow && customEvent && customEvent.performers) {
      GroupShowStore.receivedGroupShowEvent(customEvent);
    }
    let subscribedToOneOfTheAnchors = false;

    if (spotlights.length) {
      subscribedToOneOfTheAnchors = isSubscribedToGroupShowAnchorByUsername(user, broadcastingTemptationUsername);
      spotlights.forEach((spotlight) => {
        const isSubbedToOneParticipantInSpotlight = isSubscribedToGroupShowAnchorByUsername(user, spotlight?.isSpotlightByTemptationUsername);
        if (isSubbedToOneParticipantInSpotlight) {
          subscribedToOneOfTheAnchors = isSubbedToOneParticipantInSpotlight;
        }
      });
    }

    LiveBroadcastStore.setSubscribedToOneOfTheAnchors(subscribedToOneOfTheAnchors);

    const subscribed =
      user.user && user.user.account.anchorSubscriptions ? user.user.account.anchorSubscriptions.filter((anchor) => anchor.subCategory === anchorId).length > 0 : false;

    const isGuest = guestUser && guestUser?.includes('guest');
    const isNotSubscribed = !subscribed && !subscribedToOneOfTheAnchors;
    const shouldChangeNsfwFlag = isGuest || isNotSubscribed;

    if (customEvent && shouldChangeNsfwFlag && changeNsfwFlag) {
      changeNsfwFlag(customEvent.nsfw);
    }
    this.props.setSpotlightedByTemptationName(isSpotlightByTemptationUsername);
    LiveBroadcastStore.setChatOnline(chatOnline);
    this.setState({ roomState: roomStateEvent, subscribed, isSpotlight, spotlightedByAnchorNickname, spotlightedByAnchorUsername: isSpotlightByTemptationUsername });
  };

  roomMessagesListener = (roomMessage) => {
    if (roomMessage.type === 'CUSTOM' && roomMessage.attributes.type === 'groupShowEvent') {
      GroupShowStore.moveToGroupShow();
    }

    if (!(roomMessage.message === GROUP_SHOW_PARTICIPANT_STOPPED || roomMessage.message === GROUP_SHOW_PARTICIPANT_JOINED)) {
      this.setState((prevState) => {
        this.scrollToBottom();
        return { roomMessages: [...prevState.roomMessages, roomMessage] };
      }, () => {
        if (this.state.roomState.type !== 'ROOM_CLOSED' && this.state.chatOnline) {
          this.scrollToBottom();
        }
      });
    }
  };

  displayMessages = () => {
    const { isInGroupShow } = this.props;
    const { isSpotlight } = this.state;
    const { anchors } = AnchorStore;

    return this.state.roomMessages.map((messageObj, index) => {
      const nickname = messageObj.attributes ? messageObj.attributes.nickname : null;

      return (
        <BroadcastChatMessage
          key={`${messageObj.username}-${index}`}
          anchors={anchors}
          attributes={messageObj.attributes}
          isInGroupShow={isInGroupShow}
          isSpotlight={isSpotlight}
          message={messageObj.message}
          metadata={messageObj.metadata}
          nickname={nickname}
          source={messageObj.attributes && messageObj.attributes.smSource}
          user={this.props.user}
          username={messageObj.username}
        />
      );
    });
  };

  isValidInput = (inputMessage) => {
    const regex = /^[\r\n]+$/;
    const hasOnlyNewlines = regex.test(inputMessage);

    return !hasOnlyNewlines;
  };

  sendChat = (inputMessage) => {
    const { chatService, isInGroupShow, anchor, spotlighedAnchorUsername } = this.props;
    const { isSpotlight, messageMetadata } = this.state;

    let roomName = anchor?.username;

    if (isInGroupShow) {
      roomName = chatService?.[0]?.custom?.roomName || chatService?.custom?.roomName;
    }

    if (chatService?.roomName) {
      roomName = chatService?.roomName;
    }

    if (isSpotlight) {
      roomName = spotlighedAnchorUsername;
    }

    if (!roomName) {
      roomName = anchor?.username
    }

    const publicChatUrl = TEMPTED_WEB_CHAT_ACCESS.replace('{roomName}', roomName);

    return callApi(publicChatUrl, 'POST', {}, { message: inputMessage, messageMetadata: JSON.stringify(messageMetadata) }, {}, true, true, true);
  };

  onMessageSend = () => {
    const { inputMessage } = this.state;
    const { guestUser, isBroadcaster, openContextualOverlay, user, anchorId, isInGroupShow, nsfw } = this.props;
    const { subscribedToOneOfTheAnchors, spotlights } = LiveBroadcastStore;
    const isAnchor = user && user.user ? user.user.account.anchor : false;
    const isSubscribedToAtleastOneAnchor = user?.user?.account?.anchorSubscriptions?.length >= 1;
    const { groupShowParticipant: { anchorDetails } } = GroupShowStore;

    // Group shows - fan should be able to send a message if he is subscribed to at least one party show participant (anchor)
    let isSubscribedToGroupShowHost = false;
    let isSubscribedToGroupShowParticipant = false;

    if (isInGroupShow) {
      isSubscribedToGroupShowHost = isSubscribedToGroupShowAnchor(user, anchorId);
      isSubscribedToGroupShowParticipant = isSubscribedToGroupShowAnchor(user, anchorDetails.id);
    }

    const isSubscribedToOneGroupShowAnchor = isSubscribedToGroupShowHost || isSubscribedToGroupShowParticipant || subscribedToOneOfTheAnchors;
    // ___remove isBroadcaster part when disabling chat for anchor
    if (!isBroadcaster && (guestUser.includes('guest') ||
      (!isSubscribedToAtleastOneAnchor || nsfw) ||
      (!subscribedToOneOfTheAnchors && spotlights?.length)) && !isAnchor && !isSubscribedToOneGroupShowAnchor) {
      openContextualOverlay(true);

      return;
    }

    if (inputMessage.length > 0 && this.isValidInput(inputMessage)) {
      this.sendChat(inputMessage);
    }
    this.setState({ inputMessage: '', messageMetadata: null });
    this.scrollToBottom();
  };

  updateInputMessage = (e) => {
    if (this.state.inputMessage.length > MAX_MESSAGE_LENGTH_IN_CHARS) {
      return;
    }
    this.setState({
      inputMessage: e.target.value,
      messageMetadata: e.target.meta,
    });
  };

  onInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.onMessageSend();
    }
  };

  scrollToBottom = () => {
    const chatScrollTimeout = setTimeout(() => {
      if (this.chatConversationWrapperRef?.current?.scrollHeight) {
        this.chatConversationWrapperRef.current.scrollTop = this.chatConversationWrapperRef.current?.scrollHeight;
      }
    }, CHAT_SCROLL_TIMEOUT);
    this.setState({ chatScrollTimeout });
  };

  toggleChatLandscapeVisibility = () => {
    this.setState({ landscapeChatVisibility: !this.state.landscapeChatVisibility });
  };

  shouldShowTipButtonForGroupShow = () => {
    const {
      streamData,
      groupShowParticipant: {
        participantStreamData,
        anchorDetails,
      },
    } = GroupShowStore;
    const { user, anchorId } = this.props;
    const isSubscribedToGroupShowHost = isSubscribedToGroupShowAnchor(user, anchorId);
    const isSubscribedToGroupShowParticipant = isSubscribedToGroupShowAnchor(user, anchorDetails.id);

    if ((isSubscribedToGroupShowHost || isSubscribedToGroupShowParticipant) && (streamData || participantStreamData)) {
      return true;
    }

    return false;
  };

  render() {
    const {
      isBroadcaster,
      roomCount,
      enableToggleInLandscape,
      anchor,
      anchorId,
      user,
      canSubscribeToAnchor,
      isBanned,
      spotlighedAnchorNickname,
      spotlighedAnchorUsername,
      isTulumRealityShow,
      isInGroupShow,
      nsfw,
      shouldDisplayPlayer,
      spotlights,
    } = this.props;
    const {
      groupShowParticipant: {
        anchorDetails,
        participantStreamData,
        participantUsername,
      },
    } = GroupShowStore;
    const { isSpotlighing, isSpotlight, broadcastingTemptation, chatDisabled, chatOnline } = LiveBroadcastStore;
    const { anchors } = AnchorStore;

    let anchorData;
    if (isBroadcaster) {
      anchorData = {
        id: user.user.account.anchor.id,
        name: user.user.username,
      };
    } else {
      anchorData = {
        id: anchorId,
        name: anchor.name,
        username: anchor.username,
      };
    }
    const {
      inputMessage,
      messageMetadata,
      landscapeChatVisibility,
      spotlightedByAnchorNickname,
      spotlightedByAnchorUsername
    } = this.state;
    const { anchorSubscriptions, anchor: isAnchor } = user?.user?.account || {};

    let landscapeToggleButtonClassName = 'mobile-landscape-toggle-broadcaster-chat';
    let innerChatContainerClassName = 'broadcast-chat';
    if (enableToggleInLandscape) {
      innerChatContainerClassName += ' broadcast-chat--with-landscape-toggle-enabled';
    }
    if (!landscapeChatVisibility) {
      landscapeToggleButtonClassName += ' mobile-landscape-toggle-broadcaster-chat--chat-hidden';
      innerChatContainerClassName += ' broadcast-chat--landscape-chat-hidden';
    }

    return (
      <div
        className={classnames('broadcast-chat-container',
          {
            'hide-chat': chatDisabled,
            'hide-chat-mobile': isTulumRealityShow && (!user?.authenticated || canSubscribeToAnchor),
          })}
      >
        {isMobile && chatOnline && enableToggleInLandscape && (
          <button
            className={landscapeToggleButtonClassName}
            type="button"
            onClick={this.toggleChatLandscapeVisibility}
          >
            <Message fontSize="inherit" />
          </button>
        )}
        <div className={innerChatContainerClassName}>
          {chatOnline ? (
            <>
              <BroadcastChatHeader
                anchor={anchorData}
                isAnchor={!!user?.user?.account?.anchor}
                isAuthentified={this.props.user.authenticated}
                isBanned={isBanned}
                isInGroupShow={isInGroupShow}
                isSpotlight={isSpotlight}
                isSpotlighing={isSpotlighing}
                broadcastingTemptation={broadcastingTemptation}
                isTulumRealityShow={isTulumRealityShow} roomCount={roomCount}
                showTipBtnForGroupShow={this.shouldShowTipButtonForGroupShow()}
                spotlights={spotlights}
                spotlighedAnchorNickname={spotlighedAnchorNickname}
                anchorInfo={anchor}
                anchorDetails={anchorDetails}
                participantStreamData={participantStreamData}
                participantUsername={participantUsername}
                spotlighedAnchorUsername={spotlighedAnchorUsername}
                spotlightedByAnchorNickname={spotlightedByAnchorNickname}
                spotlightedByAnchorUsername={spotlightedByAnchorUsername}
              />

              {
                isSpotlighing && (
                  <div className="spotlight-chat-notification">
                    <SpotlightChatNotificationLabel
                      broadcastingTemptationNickname={spotlighedAnchorNickname}
                      spotlights={spotlights}
                      currentAnchor={parseInt(anchorData?.id, 10)}
                      anchors={anchors}
                    />
                  </div>
                )
              }
              {
                isSpotlight && spotlightedByAnchorNickname !== anchor.username && !isSpotlighing && (
                  <div className="spotlight-chat-notification">
                    <SpotlightChatNotificationLabel
                      broadcastingTemptationNickname={anchor.username}
                      spotlights={spotlights}
                      currentAnchor={parseInt(anchorData?.id, 10)}
                      anchors={anchors}
                    />
                  </div>
                )
              }
              <div
                ref={this.chatConversationWrapperRef}
                className={classnames('broadcast-chat-conversation-wrapper', {
                  'broadcast-chat-padding-top': (isSpotlighing || isSpotlight),
                  'chat-full-height': !nsfw && canSubscribeToAnchor && !user?.authenticated,
                })}
                style={isBroadcaster && {/* ___uncomment when disabling anchor messaging height: '100%'*/ }}
              >
                <div className="broadcast-chat-conversation">
                  {this.displayMessages()}
                </div>
              </div>
              {user.authenticated &&
                <BroadcastChatInput
                  messageMetadata={messageMetadata}
                  isAnchor={isAnchor}
                  anchorSubscriptions={anchorSubscriptions}
                  inputMessage={inputMessage}
                  updateInputMessage={this.updateInputMessage}
                  onInputKeyPress={this.onInputKeyPress}
                  onMessageSend={this.onMessageSend}
                />
              }
            </>
          ) : (
            <>
              {!isMobile && (
                <div className="broadcast-chat-offline">
                  <p>Chat is offline</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default BroadcastChat;
